import { useState } from 'react';
import { Button, Input, Stack, Text } from '@chakra-ui/react';
import { coordinateService } from '../../lib/services/coordinateService';
import { useMap } from '../map/map-context';
import { fromLonLat } from 'ol/proj';

export default function PolygonIDSearch({ onClose }: { onClose: () => void }) {
  const [polygonId, setPolygonId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { map } = useMap();

  const handleSearch = async () => {
    if (!polygonId.trim()) {
      setError('Please enter a polygon ID');
      return;
    }

    let searchId = polygonId.trim();
    if (!searchId.startsWith('SKDSS')) {
      searchId = `SKDSS${searchId}`;
    }

    setLoading(true);
    setError('');

    try {
      const coordinates = await coordinateService.getCoordinateByPolygonId(searchId);

      if (map) {
        const view = map.getView();
        view.animate({
          center: fromLonLat([coordinates.longitude, coordinates.latitude]),
          zoom: 14,
          duration: 1000,
        });
        onClose();
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to find polygon');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Stack gap='4'>
      <Text fontSize='sm' color='gray.600'>
        Enter a polygon ID (SKDSS prefix will be added automatically)
      </Text>

      <div>
        <Text fontSize='sm' mb='1'>
          Polygon ID
        </Text>
        <Input
          placeholder='e.g. 123456 or SKDSS123456'
          value={polygonId}
          onChange={(e) => setPolygonId(e.target.value.toUpperCase())}
          onKeyPress={handleKeyPress}
        />
      </div>

      {error && (
        <Text color='red.500' fontSize='sm'>
          {error}
        </Text>
      )}

      <Button onClick={handleSearch} loading={loading} disabled={!polygonId.trim()}>
        Search Polygon
      </Button>
    </Stack>
  );
}
